import { useEffect } from 'react';

import styled from '@emotion/styled';
import { staticRoutes } from 'Deer/constants/routes';
import { useDispatch } from 'react-redux';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { Calendar } from 'assets/assetsV1/iconComponents';

import { isMobileView } from 'constants/isMobileView';

import { getCalendarAuthDetailsV2 } from 'services/plugins';

import { Button } from 'uiToolkitV1/Button';
import { ListItemComp } from 'uiToolkitV1/ListItemComp';
import { Paper } from 'uiToolkitV1/Paper';

import { updateCalendarSync, useCreateOneOnOneDrawerData } from './slice/CreateOneOnOneDrawerSlice';

const Container = styled(Paper)`
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  padding: 16px 20px;
  margin-bottom: 4px;
  .calendar-sync-section {
    width: 80%;
  }
  .other-info {
    overflow: visible;
    white-space: normal;
    text-overflow: clip;
  }
  .chakra-text {
    white-space: normal;
  }
`;

const CalendarSyncSection = () => {
  // const { state, updateCalendarSync } = useCreateOneOnOneContext();
  const dispatch = useDispatch();

  const { isCalendarSynced } = useCreateOneOnOneDrawerData();

  const redirectURL = checkNewNavEnabled()
    ? `https://${window.location.host}${staticRoutes['my-data']['my-settings'].calendar}`
    : `https://${window.location.host}/moduleSettings?module=oneOnOne&activeTabId=calendar`;

  useEffect(() => {
    getCalendarAuthDetailsV2()
      .then((res) => {
        const { status } = res ?? {};

        dispatch(updateCalendarSync({ isCalendarSynced: status }));
      })
      .catch((err) => console.error(err));
  }, []);

  if (isCalendarSynced?.isCalendarSynced) {
    return null;
  }

  return (
    <Container>
      <ListItemComp
        withoutBackground
        LeftComponent={Calendar}
        title="Your Calendar is not synced with mesh."
        subTitle={
          isMobileView()
            ? 'Sync your google/outlook calendar on the desktop app'
            : 'Sync your calendar to update google/outlook calendar as per your schedule'
        }
        p={0}
        px={1}
        className="calendar-sync-section"
      />
      {!isMobileView() && (
        <Button
          variant="outlined"
          onClick={() => {
            window.open(redirectURL, '_blank', 'noreferrer');
          }}
        >
          Sync Now
        </Button>
      )}
    </Container>
  );
};

export default CalendarSyncSection;
